import React from 'react';
import { Plan } from './config/plansConfig'; // Importar tipo Plan
import PlanCard from './PlanCard'; // Importar componente PlanCard

// --- INTERFACES Y TIPOS ---
type View = 'default' | 'forgot-password' | 'reset-password';
type Tab = 'login' | 'register';

interface LoginViewsProps {
  view: View;
  setView: (view: View) => void;
  activeTab: Tab;
  setActiveTab: (tab: Tab) => void;
  isLoading: boolean;
  statusMessage: string;
  setStatusMessage: (msg: string) => void;
  
  // Login
  loginUsername: string; setLoginUsername: (val: string) => void;
  loginPassword: string; setLoginPassword: (val: string) => void;
  handleLogin: (e: React.FormEvent) => void;
  loginError: string;
  registerSuccess: string;
  
  // Registro
  handleRegister: (e: React.FormEvent) => void;
  registerError: string;
  fullName: string; setFullName: (val: string) => void;
  countryCode: string; setCountryCode: (val: string) => void;
  phone: string; setPhone: (val: string) => void;
  registerEmail: string; setRegisterEmail: (val: string) => void;
  registerPassword: string; setRegisterPassword: (val: string) => void;
  countryCodes: { code: string; name: string }[];

  // Nuevo flujo de registro
  registrationStep: 'plans' | 'form';
  setRegistrationStep: (step: 'plans' | 'form') => void;
  selectedPlan: Plan | null;
  handlePlanSelection: (plan: Plan) => void;
  plans: Plan[];

  // Recuperación
  handleForgotPassword: (e: React.FormEvent) => void;
  handleResetPassword: (e: React.FormEvent) => void;
  recoveryEmail: string; setRecoveryEmail: (val: string) => void;
  newPassword: string; setNewPassword: (val: string) => void;
  confirmPassword: string; setConfirmPassword: (val: string) => void;
}


const LoginViews: React.FC<LoginViewsProps> = (props) => {
  const { view, setView, activeTab, setActiveTab, statusMessage, setStatusMessage } = props;
  // --- FUNCIÓN AUXILIAR PARA RENDERIZAR EL CONTENIDO DE LA PESTAÑA DE REGISTRO ---
  const renderRegisterContent = () => {
    if (props.registrationStep === 'plans') {
      return (
        <div>
          <h3>Elige un Plan para Empezar</h3>
          <div className="plans-grid">
            {props.plans.map(plan => (
              <PlanCard
                key={plan.id}
                plan={plan}
                isProcessing={false}
                onSelectPlan={props.handlePlanSelection}
              />
            ))}
          </div>
        </div>
      );
    }

    if (props.registrationStep === 'form' && props.selectedPlan) {
      return (
        <form onSubmit={props.handleRegister}>
          <button type="button" className="back-button-form" onClick={() => props.setRegistrationStep('plans')}>
            ← Cambiar de Plan
          </button>
          <h3>Completa tu Registro ({props.selectedPlan.title})</h3>
          {props.registerError && <p className="error-message">{props.registerError}</p>}
          
          {/* Formulario de registro completo */}
          <div className="form-row">
            <div className="input-group">
              <label htmlFor="fullName">Nombre completo</label>
              <input type="text" id="fullName" value={props.fullName} onChange={(e) => props.setFullName(e.target.value)} required />
            </div>
            <div className="input-group">
              <label>Número de teléfono</label>
              <div className="phone-input-group">
                <select value={props.countryCode} onChange={e => props.setCountryCode(e.target.value)}>
                  {props.countryCodes.map(c => <option key={c.code} value={c.code}>{c.name} ({c.code})</option>)}
                </select>
                <input type="tel" id="phone" value={props.phone} onChange={(e) => props.setPhone(e.target.value)} placeholder="Número" />
              </div>
            </div>
          </div>
          <div className="form-row">
            <div className="input-group">
              <label htmlFor="register-email">Correo electrónico</label>
              <input type="email" id="register-email" value={props.registerEmail} onChange={(e) => props.setRegisterEmail(e.target.value)} required />
            </div>
            <div className="input-group">
                <label htmlFor="register-password">Contraseña</label>
                <input type="password" id="register-password" value={props.registerPassword} onChange={(e) => props.setRegisterPassword(e.target.value)} required />
            </div>
          </div>
          <button type="submit" className="action-button" disabled={props.isLoading}>
            {props.isLoading ? 'Creando cuenta...' : 'Finalizar Registro'}
          </button>
        </form>
      );
    }
    return null;
  };


  switch (view) {
    case 'forgot-password':
      return (
        <div>
          <h3>Recuperar Contraseña</h3>
          <p className="subtitle">Introduce tu correo electrónico para recibir instrucciones.</p>
          <form onSubmit={props.handleForgotPassword}>
            <div className="input-group">
              <label htmlFor="recovery-email">Correo Electrónico</label>
              <input type="email" id="recovery-email" value={props.recoveryEmail} onChange={(e) => props.setRecoveryEmail(e.target.value)} required />
            </div>
            {statusMessage && <p className={statusMessage.startsWith('¡') ? 'success-message' : 'error-message'}>{statusMessage}</p>}
            <button type="submit" className="action-button" disabled={props.isLoading}>
              {props.isLoading ? 'Enviando...' : 'Enviar Instrucciones'}
            </button>
          </form>
        </div>
      );
    case 'reset-password':
      return (
        <div>
          <h3>Restablecer Contraseña</h3>
          <p className="subtitle">Introduce tu nueva contraseña.</p>
          <form onSubmit={props.handleResetPassword}>
            
              <div className="input-group">
                <label htmlFor="new-password">Nueva Contraseña</label>
                <input type="password" id="new-password" value={props.newPassword} onChange={(e) => props.setNewPassword(e.target.value)} required />
              </div>
              <div className="input-group">
                <label htmlFor="confirm-password">Confirmar Nueva Contraseña</label>
                <input type="password" id="confirm-password" value={props.confirmPassword} onChange={(e) => props.setConfirmPassword(e.target.value)} required />
              </div>
            
            {statusMessage && <p className={statusMessage.startsWith('¡') ? 'success-message' : 'error-message'}>{statusMessage}</p>}
            <button type="submit" className="action-button" disabled={props.isLoading}>
              {props.isLoading ? 'Actualizando...' : 'Actualizar Contraseña'}
            </button>
          </form>
        </div>
      );

    default:
      return (
        <>
          <div className="tabs-container">
            <button className={`tab-button ${activeTab === 'login' ? 'active' : ''}`} onClick={() => setActiveTab('login')}>Iniciar Sesión</button>
            <button 
              className={`tab-button ${activeTab === 'register' ? 'active' : ''}`} 
              onClick={() => {
                setActiveTab('register');
                props.setRegistrationStep('plans'); }}>
              Regístrate
            </button>
          </div>
          {activeTab === 'login' ? (
            <form onSubmit={props.handleLogin}>
              {props.registerSuccess && <p className="success-message">{props.registerSuccess}</p>}
              {props.loginError && <p className="error-message">{props.loginError}</p>}
              <div className="form-row">
                <div className="input-group">
                  <label htmlFor="login-username">Email del Usuario</label>
                  <input type="text" id="login-username" value={props.loginUsername} onChange={(e) => props.setLoginUsername(e.target.value)} placeholder="Tu email" required />
                </div>
                <div className="input-group">
                  <label htmlFor="login-password">Contraseña</label>
                  <input type="password" id="login-password" value={props.loginPassword} onChange={(e) => props.setLoginPassword(e.target.value)} placeholder="Tu contraseña" required />
                </div>
              </div>
              <button type="submit" className="action-button" disabled={props.isLoading}>{props.isLoading ? 'Iniciando...' : 'Iniciar Sesión'}</button>
            </form>
          ) : (renderRegisterContent()
          )}
          {activeTab === 'login' && (
            <div className="form-footer">
              <a href="#" onClick={(e) => { 
                e.preventDefault(); 
                setView('forgot-password'); 
                setStatusMessage(''); }}>
                ¿Olvidaste tu contraseña?
              </a>
            </div>
          )}
        </>
      );
  }
};

export default LoginViews;